import {
  DECIMAL_SEPARATOR,
  IAmountDisplayConfig,
  IPagesConfigs,
  THOUSANDS_SEPARATOR,
} from 'api/portalUser/types';

export const WORKBOOK_PAGE_KEY = 'SETTLEMENT_CONTRACTS_WORKBOOK';

export const DEFAULT_AMOUNT_DISPLAY: IAmountDisplayConfig = {
  decimalSeparator: DECIMAL_SEPARATOR.DOT,
  thousandsSeparator: THOUSANDS_SEPARATOR.NONE,
};

const SEPARATOR_CHARS: Record<DECIMAL_SEPARATOR | THOUSANDS_SEPARATOR, string> = {
  [DECIMAL_SEPARATOR.DOT]: '.',
  [THOUSANDS_SEPARATOR.APOSTROPHE]: "'",
  [THOUSANDS_SEPARATOR.COMMA]: ',',
  [THOUSANDS_SEPARATOR.NONE]: '',
  [THOUSANDS_SEPARATOR.SPACE]: ' ',
};

// Per-contract records live on a composed page key; the user-global record
// lives on the base page key
export const getContractPageKey = (pageKey: string, contractId: string): string =>
  `${pageKey}/${contractId}`;

export const getEffectiveAmountDisplayConfig = (
  pages: IPagesConfigs | undefined,
  pageKey: string,
  contractId: string,
): IAmountDisplayConfig =>
  pages?.[getContractPageKey(pageKey, contractId)]?.amountDisplay ||
  pages?.[pageKey]?.amountDisplay ||
  DEFAULT_AMOUNT_DISPLAY;

// Display-only formatting: decimals stay exactly as stored (no rounding, no padding),
// which rules out toLocaleString/Intl — hence the manual string split
export const formatAmount = (
  value: null | number | string | undefined,
  config: IAmountDisplayConfig,
): string => {
  if (value === null || value === undefined || value === '' || value === '-') {
    return '-';
  }

  const raw = String(value);
  const isNegative = raw.startsWith('-');
  const [integer, decimal] = (isNegative ? raw.slice(1) : raw).split('.');

  const thousandsChar = SEPARATOR_CHARS[config.thousandsSeparator];
  const grouped = thousandsChar
    ? integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsChar)
    : integer;

  const decimalPart =
    decimal === undefined ? '' : `${SEPARATOR_CHARS[config.decimalSeparator]}${decimal}`;

  return `${isNegative ? '-' : ''}${grouped}${decimalPart}`;
};
